import { apicall, apicallWithoutInterceptor } from "../../services/api";
import {
	USER_LOADED,
	AUTH_ERROR,
	LOGIN_SUCCESS,
	LOGIN_FAIL,
	LOGOUT,
	LOGIN_LOADING
} from "./actionTypes";
import setAuthToken from "../../services/setAuthToken";
import { toast } from "react-hot-toast";
// import { Alert } from "@mui/material";

export const loadUser = () => async (dispatch) => {
	if (localStorage.accessToken) {
		try {
			setAuthToken(localStorage.accessToken);
			const res = await apicallWithoutInterceptor("users/auth", "get");

			dispatch({
				type: USER_LOADED,
				payload: res.data.data.UserInfo,
			});
		} catch (err) {
			dispatch({
				type: AUTH_ERROR,
			});
		}
	} else {
		dispatch({
			type: AUTH_ERROR,
		});
	}
};

//Login User
export const login = (user_email, password) => async (dispatch) => {
	const body = { user_email, password };
	try {
		//const res = await api.post("/users/login", body);
		const res = await apicallWithoutInterceptor(`users/login`, "post", body);

		dispatch({
			type: LOGIN_SUCCESS,
			payload: res.data,
		});
		
		toast.success("Login Successful");
		return res.data;
		//dispatch(loadUser());
	} catch (err) {
		// console.log("Err>>>", err);
		const errors = err.response?.data?.errors;
		// const errMsg = err;

		if (errors) {
			errors.forEach((error) => console.log(error));
		}
		// <Alert></Alert>

		return dispatch({
			type: LOGIN_FAIL,
			msg: err.response?.data?.msg
		});
	}
};

export const refreshToken = (accessToken) => async(dispatch) =>{
	if (localStorage.accessToken) {
		try {
			dispatch({
				type: LOGIN_LOADING,
			});
			const res = await apicallWithoutInterceptor("users/refresh_token", "get");
			const data = await res?.data || {}
			dispatch({
				type: LOGIN_SUCCESS,
				payload: data,
			});
			if(data){
				dispatch(loadUser());
			}
		} catch (err) {
			return dispatch({
				type: AUTH_ERROR,
			});
		}
	}else{
		return dispatch({
			type: LOGIN_FAIL,
			msg: "No Access Token"
		});
	}
}

//Logout / Clear profile
export const logout = () => (dispatch) => {
	dispatch({ type: LOGOUT });
};
